import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

interface Props {
  onClose: () => void;
  children: React.ReactNode;
}

function BottomModal({ onClose, children }: Props) {
  // 모달 열릴 때 body 스크롤 막기
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const modalContent = (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </ModalContainer>
    </ModalOverlay>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default BottomModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  max-height: 640px;
  display: flex;
  flex-direction: column;
`;
